export default __webpack_public_path__ + "static/media/Cairo-Bold.f40d8836.ttf";